import React, { useState, useEffect } from "react";
import { DisplayDiscussionForMiniScreenProvider } from "../contexts/DisplayDiscussionForMiniScreenContext";
import Navbar from "../components/Navbar";
import ContentSquelette from "../layouts/ContentSquelette";
import OffCanvas from "../components/OffCanvas";
import { getUsers } from "../services/comptes-users";
import { getCachedList, cacheList } from "../services/messageCache";
import DisplayContact from "../components/DisplayContact";
import Discussion from "../components/Discussion";

export default function ContactsPage() {
  const [users, setUsers] = useState([]);

  useEffect(() => {
    if (users.length > 0) return;
    // Afficher le cache immédiatement, puis rafraîchir depuis le serveur
    getCachedList("annuaire").then((cached) => {
      if (cached) setUsers(cached);
    });
    getUsers({}, (freshUsers) => {
      setUsers(freshUsers);
      cacheList("annuaire", freshUsers);
    });
  }, []);

  return (
    <>
      <DisplayDiscussionForMiniScreenProvider>
        <Navbar />
        <ContentSquelette>
          <OffCanvas
            panel="Annuaire"
          >
            <ul className="tyn-media-list gap gap-3">
              {users.map((contact, idx) => (
                  <DisplayContact key={idx} idx={idx} userT={contact} />
                ))
              }
            </ul>
          </OffCanvas>
          <Discussion />
        </ContentSquelette>
      </DisplayDiscussionForMiniScreenProvider>
    </>
  );
}
